import { logInfo } from "@common/Logger";
import { ValidationError } from "@common/types";
import Cookies from "js-cookie";
import { connection } from "../_Workflows/connection";

function getHeadersOld() {
    const headers = [];
    headers.push({ Name: "tch.sid", Value: Cookies.get("AppRT.SessionId") });
    headers.push({ Name: "Context", Value: window.location.hash.replace("#", "") });
    headers.push({ Name: "Url", Value: window.location.href });

    for (const name in Cookies.get()) {
        if (name.indexOf("AppRT_Header_") == 0) {
            const header = JSON.parse(Cookies.get(name));
            headers.push(header);
        }
    }
    return headers;
}

function getHeaders(correlationId: string) {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'tch.sid': Cookies.get('AppRT.SessionId') || '',
        'CorrelationId': correlationId,
        'Context': window.location.hash.replace('#', ''),
        'Url': window.location.href
    };

    const allCookies = Cookies.get();
    for (const name in allCookies) {
        if (name.startsWith("AppRT_Header_")) {
            try {
                const header = JSON.parse(allCookies[name]);
                Object.assign(headers, header);
            } catch (error) {
                console.warn(`Invalid JSON in cookie: ${name}`, error);
            }
        }
    }

    return headers;
}

export interface IQueryBase {
    $type: string;
}

export interface IQueryStatus {
    Query: any;
    Model: any;
    ModelName: string;
    ModelFullName: string;
    Auth: boolean;
    Success: boolean;
    CorrelationId: string;
    RedirectUrl: string;
    Error: string | null;
}

export interface ICommandStatus {
    Command: any;
    Success: boolean;
    Result: any;
    CorrelationId: string;
    Auth: boolean;
    Error?: string | null;
    ValidationErrors?: ValidationError[];
}

export enum CommunicationMode {
    Http = 1,
    SignalR = 2
}

const queryStatusSubscribers = new Set<(status: IQueryStatus) => void>();
const commandStatusSubscribers = new Set<(status: ICommandStatus) => void>();

function handleSetQueryStatus(status: IQueryStatus) {
    console.log('Query status', status)
    queryStatusSubscribers.forEach((callback) => callback(status));
}

function handleSetCommandStatus(status: ICommandStatus) {
    console.log('Command status', status)
    commandStatusSubscribers.forEach((callback) => callback(status));
}

connection.on("SetQueryStatus", handleSetQueryStatus);
connection.on("SetCommandStatus", handleSetCommandStatus);

export function subscribeSetQueryStatus(onSetQueryStatus: (status: IQueryStatus) => void) {
    queryStatusSubscribers.add(onSetQueryStatus);
}

export function unsubscribeSetQueryStatus(onSetQueryStatus: (status: IQueryStatus) => void) {
    queryStatusSubscribers.delete(onSetQueryStatus);
}

export function subscribeSetCommandStatus(onSetCommandStatus: (status: ICommandStatus) => void) {
    commandStatusSubscribers.add(onSetCommandStatus);
}

export function unsubscribeSetCommandStatus(onSetCommandStatus: (status: ICommandStatus) => void) {
    commandStatusSubscribers.delete(onSetCommandStatus);
}

export function query(query: any, correlationId: string, mode: CommunicationMode = CommunicationMode.Http, retries = 30) {
    logInfo(`Query (correlationId=${correlationId})`, query);

    if (mode == CommunicationMode.Http) {
        fetch('/domain/queries',
            {
                method: 'POST',
                headers: getHeaders(correlationId),
                body: JSON.stringify(query),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`)
                }
                return response.json()
            })
            .then(status => {
                //console.log(status)
                handleSetQueryStatus(status)
            })
            .catch(error => {
                console.error('Error:', error)
            })
    }
    else if (mode == CommunicationMode.SignalR) {
        connection.send("HandleQuery", "*/*", query, correlationId, getHeadersOld())
            .catch(() => {
                if (retries > 0) {
                    const h = setTimeout(() => {
                        query(query, correlationId, retries - 1);
                        clearTimeout(h);
                    }, 10000)
                }
            });
    }
}

export function command(cmd: any, correlationId: string, mode: CommunicationMode = CommunicationMode.Http, retries = 30) {
    logInfo('Command', cmd)

    if (mode == CommunicationMode.Http) {
        fetch('/domain/commands',
            {
                method: 'POST',
                headers: getHeaders(correlationId),
                body: JSON.stringify(cmd),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`)
                }
                return response.json()
            })
            .then(status => {
                //console.log(status)
                handleSetCommandStatus(status)
            })
            .catch(error => {
                console.error('Error:', error)
            })
    }
    else if (mode == CommunicationMode.SignalR) {
        connection.send("HandleCommand", "*/*", cmd, correlationId, getHeadersOld())
            .catch(() => {
                if (retries > 0) {
                    const h = setTimeout(() => {
                        command(cmd, correlationId, retries - 1);
                        clearTimeout(h);
                    }, 10000)
                }
            });
    }
}
